export const privacyPolicyConstants = {
  ADD_OR_UPDATE_PRIVACY_POLICY: "ADD_OR_UPDATE_PRIVACY_POLICY",
  GET_PRIVACY_POLICY: "GET_PRIVACY_POLICY",
};